// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".color-section{content-visibility:auto}.color-section--opaque{content-visibility:unset}.color-section--bounded{position:relative}.color-section__gradient{height:var(--header-height);left:0;position:absolute;width:100%}.color-section__gradient--top{bottom:100%}.color-section__gradient--bottom{top:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
